import { Box, Paper, Typography } from '@mui/material'
import { styled, alpha, keyframes } from '@mui/material/styles'

export const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`

export const typingBounce = keyframes`
  0%, 60%, 100% { transform: translateY(0) scale(1); opacity: 0.7; }
  30% { transform: translateY(-8px) scale(1.1); opacity: 1; }
`

export const dotFade = keyframes`
  0%, 20% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginBottom: theme.spacing(3),
  padding: theme.spacing(0, 2),
}))

export const AvatarBox = styled(Box)(({ theme }) => ({
  width: 32,
  height: 32,
  marginRight: theme.spacing(1.5),
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontWeight: 600,
  flexShrink: 0,
}))

export const ChatBubble = styled(Paper)(({ theme }) => ({
  maxWidth: '75%',
  minWidth: 200,
  padding: theme.spacing(2.5),
  borderRadius: '16px 16px 16px 4px',
  animation: `${fadeInUp} 0.3s ease-out`,
  background: theme.palette.mode === 'dark' ? alpha('#fff', 0.05) : '#f8fafc',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 1px 4px rgba(0,0,0,0.3)'
      : '0 1px 4px rgba(0,0,0,0.04)',
}))

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1.5),
}))

export const Name = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '0.8rem',
  letterSpacing: '0.02em',
  textTransform: 'uppercase',
  opacity: 0.85,
}))

export const Timer = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: '0.7rem',
  opacity: 0.6,
}))

export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}))

export const DotGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  height: 20,
}))

export const Dot = styled(Box)(({ theme, brandcolor, delay }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: brandcolor,
  animation: `${typingBounce} 1.4s ease-in-out infinite`,
  animationDelay: `${delay}s`,
}))

export const Status = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontStyle: 'italic',
  opacity: 0.8,
  display: 'flex',
  alignItems: 'center',
}))

export const StatusDot = styled('span')(({ delay }) => ({
  display: 'inline-block',
  animation: `${dotFade} 1.4s ease-in-out infinite`,
  animationDelay: `${delay}s`,
  marginLeft: 2,
  opacity: 0,
}))
